import React from 'react';
import PropTypes from 'prop-types';
// import FlippingPages from 'flipping-pages';
import FlippingPages from '@/components/FlippingPages';
import 'flipping-pages/FlippingPages.css';
import { DEVICE, IDENTITY_KEY_NAME } from '@/constants';
import { OS, getIdentity } from '@/utils/detectDevice';

class Page extends React.Component {
  static propTypes = {
    generateResult: PropTypes.func,
    onPlay: PropTypes.func,
    renderReadingEffect: PropTypes.func,
    bookData: PropTypes.array,
    evaluating: PropTypes.bool,
    isPlay: PropTypes.bool,
    barDis: PropTypes.bool,
    readDis: PropTypes.bool,
    result: PropTypes.array,
    changePages: PropTypes.func,
    bookIndex: PropTypes.number,
    isSenior: PropTypes.bool,
  };

  constructor() {
    super();
    this.state = {
      isDragging: false,
      offsetX: 0,
      // offsetY: 0,
      phase: '',
      selected: 0,
      url: `${OS.URL_HOST()}Library/`,
      appName: getIdentity(IDENTITY_KEY_NAME.APP_NAME),
    };
    this.panes = React.createRef();
  }

  componentWillMount() {
    OS.TYPE === DEVICE.PC || this.state.appName === 'STUDENT'
      ? import('./stylePc.less')
      : import('./style.less');
  }

  componentDidMount() {
    this.init();
  }

  init = () => {
    this.setState({
      selected: this.props.bookIndex - 1,
    }, () => {
      (OS.TYPE === DEVICE.MOBILE
        || (OS.TYPE !== DEVICE.PC && this.state.appName !== 'STUDENT'))
        && this.swipegoryUpdate();
    });
  }

  handleSelectedChange = (selected) => {
    this.setState({ selected }, () => this.props.changePages(selected));
  }

  play = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onPlay();
  }

  startDrag = (e) => {
    e.stopPropagation();
    const dv = e.currentTarget;
    let touch = null;
    if (e.touches) {
      touch = {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
      };
    } else {
      touch = e;
    }
    const offsetX = touch.clientX - (OS.TYPE === DEVICE.PC || this.appName === 'STUDENT' ? dv.offsetLeft : 0);
    this.setState({
      offsetX,
    });
  };

  dragging = (e) => {
    if (e.target && typeof e.target.closest === 'function' && e.target.closest('.word-box')) {
      return;
    }
    const { offsetX } = this.state;
    let touch = null;
    if (e.touches) {
      touch = {
        clientX: e.touches[0].clientX,
      };
    } else {
      touch = e;
    }
    const x = touch.clientX - offsetX;
    let phase = '';
    const moveDistance = 50;
    if (Math.abs(x) && x > moveDistance) {
      phase = 'right';
    } else if (Math.abs(x) && x < -moveDistance) {
      phase = 'left';
    }
    document.querySelector('.book-pages.cur') && (document.querySelector('.book-pages.cur').style.marginLeft = phase === 'left' ? `-${x}px` : `${x}px`);
    this.setState({
      phase,
      isDragging: true,
    });
  };

  endDrag = () => {
    const {
      isDragging,
      phase,
    } = this.state;
    if (isDragging) {
      document.querySelector('.book-pages.cur') && (document.querySelector('.book-pages.cur').style.marginLeft = '0px');
      this.setState({
        isDragging: false,
      }, () => {
        this.swipegoryUpdate(phase);
      });
    }
  };

  swipegoryUpdate = (phase) => {
    const { selected, appName } = this.state;
    const panes = this.panes.current;
    let goTo = phase === 'left' ? selected + 1 : selected - 1;
    goTo = !phase ? selected : goTo;
    const prev = goTo - 1;
    const next = goTo + 1;
    if (appName !== 'STUDENT' && panes && goTo >= 0 && goTo < panes.childNodes.length) {
      for (let i = 0; i < panes.childNodes.length; i += 1) {
        const pane = panes.childNodes[i];
        pane.className = 'book-pages';
        if (i === prev) {
          pane.className = 'book-pages prev';
        } else if (i === next) {
          pane.className = 'book-pages next';
        } else if (i < goTo) {
          pane.className = 'book-pages before';
        } else if (i === goTo) {
          pane.className = 'book-pages cur';
        } else if (i > goTo) {
          pane.className = 'book-pages after';
        }
      }
      goTo !== selected && this.handleSelectedChange(goTo);
    }
    (appName === 'STUDENT' || OS.TYPE === DEVICE.PC)
      && (goTo !== -1 && goTo < this.props.bookData.length)
      && goTo !== selected && this.handleSelectedChange(goTo);
  }

  render() {
    const {
      result,
      evaluating,
      bookData,
      barDis,
      isPlay,
      readDis,
      bookIndex,
      isSenior,
    } = this.props;
    return (
      OS.TYPE === DEVICE.PC || this.state.appName === 'STUDENT'
        ? (
          <FlippingPages
            className="book-pages"
            direction="horizontal"
            selected={this.state.selected}
            onSelectedChange={this.handleSelectedChange}
            touch-action="none"
            animationDuration={200}
            swipeLength={200}
            thresholdSpeed={10}
          >
            {
              bookData.map((pageData, i) => (
                <div
                  className="book-pages"
                  key={`bookPages ${i + 1}`}
                >
                  <div className={`${isSenior ? 'senior' : 'junior'}-page-left`}>
                    <div className={`${isSenior ? 'senior' : 'junior'}-img-box`}>
                      <img className={`${isSenior ? 'senior' : 'junior'}-img`} src={`${this.state.url}${pageData.title_id}/${pageData.title_id}_Image.png`} alt="" />
                    </div>
                  </div>
                  <div className={`${isSenior ? 'senior' : 'junior'}-page-right${pageData.has_png === 0 ? ' no-pic' : ''}`}>
                    <div className={`word-box${barDis ? '' : ' add-height'}`}>
                      <div className={`play${isPlay ? ' playing' : ''}${readDis ? ' dis' : ''}`} onClick={!readDis ? this.play : null} />
                      {bookIndex === (i + 1) && (!evaluating && result.length) > 0
                        ? this.props.generateResult(result)
                        : this.props.renderReadingEffect()}
                    </div>
                  </div>
                </div>
              ))
            }
          </FlippingPages>
        )
        : (
          <div
            className="panes"
            onTouchStart={this.startDrag}
            onTouchMove={this.dragging}
            onTouchEnd={this.endDrag}
            ref={this.panes}
          >
            {
              bookData.map((pageData, i) => (
                <div className="book-pages" key={`bookPages ${i + 1}`}>
                  <div className="page-left">
                    {pageData.has_png !== 0
                      ? (<div className={`${isSenior ? 'senior' : 'junior'}-img-box`}>{(i === bookIndex - 2 || i === bookIndex - 1 || i === bookIndex) && <img className={`${isSenior ? 'senior' : 'junior'}-img`} src={`${this.state.url}${pageData.title_id}/${pageData.title_id}_Image.png`} alt="" />}</div>)
                      : null
                    }
                  </div>
                  <div className={`${isSenior ? 'senior' : 'junior'}-page-right${pageData.has_png === 0 ? ' no-pic' : ''}`}>
                    <div className={`word-box${barDis || pageData.has_png === 0 ? '' : ' add-height'}${pageData.has_png === 0 ? ' no-pic' : ''}`}>
                      <div className={`play${isPlay ? ' playing' : ''}${readDis ? ' dis' : ''}`} onClick={!readDis ? this.play : null} />
                      <div>
                        {i === bookIndex - 1 && (!evaluating && result.length > 0
                          ? this.props.generateResult(result)
                          : this.props.renderReadingEffect())}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        )
    );
  }
}
export default Page;
